import React, { createContext, useState } from 'react';
// ******* CONTEXT ******
export var EditPickupLocationContext = createContext({});
// ******* PROVIDER ******
export function EditPickupLocationProvider(_a) {
    var children = _a.children;
    var _b = useState(true), isStoreSelection = _b[0], setIsStoreSelection = _b[1];
    var _c = useState(false), isConfirmation = _c[0], setIsConfirmation = _c[1];
    var _d = useState(false), skeletonLoading = _d[0], setSkeletonLoading = _d[1];
    var _e = useState(), storeLocationData = _e[0], setStoreLocationData = _e[1];
    var _f = useState(false), isLocationChangeConfirmed = _f[0], setIsLocationChangeConfirmed = _f[1];
    var _g = useState(), selectedStoreData = _g[0], setSelectedStoreData = _g[1];
    var _h = useState(), editPickupLocationOrderIds = _h[0], setEditPickupLocationOrderIds = _h[1];
    return (React.createElement(EditPickupLocationContext.Provider, { value: {
            isStoreSelection: isStoreSelection,
            setIsStoreSelection: setIsStoreSelection,
            isConfirmation: isConfirmation,
            setIsConfirmation: setIsConfirmation,
            skeletonLoading: skeletonLoading,
            setSkeletonLoading: setSkeletonLoading,
            storeLocationData: storeLocationData,
            setStoreLocationData: setStoreLocationData,
            isLocationChangeConfirmed: isLocationChangeConfirmed,
            setIsLocationChangeConfirmed: setIsLocationChangeConfirmed,
            selectedStoreData: selectedStoreData,
            setSelectedStoreData: setSelectedStoreData,
            editPickupLocationOrderIds: editPickupLocationOrderIds,
            setEditPickupLocationOrderIds: setEditPickupLocationOrderIds,
        } }, children));
}
